export default "__VITE_ASSET__5bf91076__"